// Display helpers for the Nachunternehmer pages: traffic lights, statuses, warning texts.

export {
  formatEuro,
  formatDay,
  formatDateTime,
  euroToCents,
  centsToEuro,
  decimalInputProps
} from "../workReports/format";

export const LEVEL_COLORS = { green: "success", amber: "warning", red: "error" };

export const levelLabels = t => ({
  green: t("Documents complete"),
  amber: t("Please check"),
  red: t("Documents missing")
});

export const STATUS_COLORS = {
  valid: "success",
  expiring: "warning",
  pending_review: "processing",
  missing: "error",
  expired: "error",
  rejected: "default",
  not_yet_valid: "warning"
};

export const statusLabels = t => ({
  valid: t("Valid"),
  expiring: t("Expires soon"),
  pending_review: t("Waiting for review"),
  missing: t("Missing"),
  expired: t("Expired"),
  rejected: t("Rejected"),
  not_yet_valid: t("Not yet valid")
});

// Document types keep their German legal names in every language (the server sends them).
export const typeLabel = (types, key) => (types || []).find(x => x.key === key)?.label || key;

export const guaranteeLabels = t => ({
  performance: t("Performance bond"),
  warranty: t("Warranty bond"),
  advance_payment: t("Advance payment bond")
});

export const orderStatusLabels = t => ({
  draft: t("Draft"),
  active: t("Active"),
  completed: t("Completed"),
  cancelled: t("Cancelled")
});

const warningLabels = t => ({
  FREISTELLUNG_MISSING: t("No Freistellungsbescheinigung: 15 % must be withheld (§ 48 EStG)."),
  FREISTELLUNG_EXPIRED: t(
    "The Freistellungsbescheinigung has expired: 15 % must be withheld (§ 48 EStG)."
  ),
  FREISTELLUNG_NOT_YET_VALID: t(
    "The Freistellungsbescheinigung is not yet valid: 15 % must be withheld (§ 48 EStG)."
  ),
  FREISTELLUNG_UNCONFIRMED: t(
    "The Freistellungsbescheinigung is not confirmed yet: 15 % must be withheld (§ 48 EStG)."
  ),
  FREISTELLUNG_INVALID: t("No valid Freistellungsbescheinigung on the start day."),
  FREISTELLUNG_MISSING_BAGATELL: t(
    "No Freistellungsbescheinigung, but this year's payments stay within the 5,000 € limit: nothing is withheld yet."
  ),
  DOCUMENTS_INCOMPLETE: t("Required documents are missing or expired."),
  DOCUMENTS_EXPIRING: t("Documents expire within 30 days."),
  NOT_WITHHELD_ON_BELEG: t("This invoice was booked without withholding the Bauabzugsteuer."),
  VAT_CHARGED_ALTHOUGH_13B: t(
    "The invoice shows VAT, but you owe the tax under § 13b UStG (reverse charge)."
  ),
  REVERSE_CHARGE_WITHOUT_BAULEISTER_STATUS: t(
    "Reverse charge on the invoice, but your company is not set up as a Bauleistender (accounting settings)."
  ),
  REVERSE_CHARGE_FROM_KLEINUNTERNEHMER: t("Reverse charge does not apply to a Kleinunternehmer."),
  NOT_A_CERTIFICATE: t("This does not look like a certificate."),
  TYPE_MISMATCH: t("The document seems to be of another type."),
  HOLDER_MISMATCH: t("The document seems to be issued for another company.")
});

export const warningText = (t, code) => warningLabels(t)[code] || code;
